// src/ConveLogin.tsx

import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { conveAuthApi, conveTokenHelper } from './api/conveApi';
import './ConveLogin.css';

const ConveLogin: React.FC = () => {
  const navigate = useNavigate();

  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  //저장된 테마가 없으면 라이트 테마
  useEffect(() => {
    const saved = localStorage.getItem('conve_theme') || 'light';
    document.documentElement.setAttribute('data-theme', saved);
  }, []);

  // 이미 로그인 상태면 메인으로
  useEffect(() => {
    if (conveTokenHelper.isLoggedIn()) {
      navigate('/conve', { replace: true });
    }
  }, []);

  const handleLogin = async () => {
    if (!email.trim() || !password.trim()) {
      setError('이메일과 비밀번호를 입력해주세요.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await conveAuthApi.login(email.trim(), password);
      const { accessToken, refreshToken, userId, username, email: userEmail } = res.data;
      conveTokenHelper.save(accessToken, refreshToken, { userId, username, email: userEmail });
      navigate('/conve', { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !loading) handleLogin();
  };

  return (
    <div className="conve-auth-wrap">
      <div className="conve-logo">CONV<span>E</span></div>
      <div className="conve-logo-tag">POWERED BY Backend-Lab.com</div>

      <div className="conve-card">
        <div className="conve-card-title">로그인</div>

        <div className="conve-field">
          <label className="conve-label">이메일</label>
          <input
            className={`conve-input ${error ? 'error' : ''}`}
            type="email"
            placeholder="이메일을 입력하세요"
            value={email}
            onChange={e => { setEmail(e.target.value); setError(''); }}
            onKeyDown={handleKeyDown}
            disabled={loading}
            autoFocus
          />
        </div>

        <div className="conve-field" style={{ marginBottom: '20px' }}>
          <label className="conve-label">비밀번호</label>
          <input
            className={`conve-input ${error ? 'error' : ''}`}
            type="password"
            placeholder="비밀번호를 입력하세요"
            value={password}
            onChange={e => { setPassword(e.target.value); setError(''); }}
            onKeyDown={handleKeyDown}
            disabled={loading}
          />
          {error && <div className="conve-msg error">{error}</div>}
        </div>

        <button
          className={`conve-btn-primary ${loading ? 'disabled' : ''}`}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading
            ? <><span className="conve-spinner-sm dark" />로그인 중...</>
            : '로그인'}
        </button>

        <div className="conve-card-footer">
          계정이 없으신가요? <Link to="/conve/register">회원가입</Link>
        </div>
      </div>
    </div>
  );
};

export default ConveLogin;